import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const COSTURA = [
  { value: "pendiente", label: "Pendiente", cls: "bg-zinc-200 text-zinc-800" },
  { value: "en_proceso", label: "En proceso", cls: "bg-amber-100 text-amber-900" },
  { value: "parcial", label: "Parcial", cls: "bg-yellow-100 text-yellow-900" },
  { value: "listo", label: "Listo", cls: "bg-emerald-100 text-emerald-900" },
  { value: "no_hay_tela", label: "No hay tela", cls: "bg-orange-100 text-orange-900" },
  { value: "no_hay_material", label: "No hay material", cls: "bg-rose-100 text-rose-900" },
];
const meta = (v) => COSTURA.find((s) => s.value === v) || COSTURA[0];

export const CosturaBadge = ({ estado }) => (
  <span className={`inline-block rounded-full px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide ${meta(estado).cls}`} data-testid="costura-badge">
    Costura: {meta(estado).label}
  </span>
);

export const CosturaSelect = ({ row, canEdit, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const change = async (estado) => {
    setBusy(true);
    try {
      await api.patch(`/costuras/${row.order_id}`, { key: row.key, estado });
      toast.success(`Costura: ${meta(estado).label}`);
      onChanged?.(estado);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  if (!canEdit) return <CosturaBadge estado={row.estado} />;
  return (
    <select
      value={row.estado}
      disabled={busy}
      onChange={(e) => change(e.target.value)}
      className={`rounded-full border-0 px-2 py-1 text-[11px] font-semibold cursor-pointer ${meta(row.estado).cls}`}
      data-testid={`costura-estado-${row.numero}-${row.key}`}
    >
      {COSTURA.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
    </select>
  );
};
